'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getStockTakes(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `stock-takes/${id}${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createStockTake(json) {
    const data = {
      method: 'post',
      url: 'stock-take',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Stock take created successfully')
      return true;
    }
  },
  async getStockTake(id) {
    const data = {
      method: 'get',
      url: 'stock-take/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async updateStockTake(json, id) {
    const data = {
      method: 'put',
      url: 'stock-take/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Stock take updated successfully')
      return true;
    }
  },
  async getStockTakeNextNo(id) {
    const data = {
      method: 'get',
      url: 'stock-takeNextNo/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getStockTakeDetails(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `stock-take/${id}/details${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  async createStockTakeDetails(json) {
    const data = {
      method: 'post',
      url: 'stock-take-details',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Stock take product added', 2000)
      return true;
    }
  },
  async updateStockTakeDetails(json, id) {
    const data = {
      method: 'put',
      url: 'stock-take-details/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Stock take product updated', 2000)
      return true;
    }
  },
  async deleteStockTakeDetails(id) {
    const data = {
      method: 'delete',
      url: 'stock-take-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Stock take product deleted', 2000)
      return true;
    }
  },
  async approveStockTake(id) {
    const data = {
      method: 'patch',
      url: 'stock-take-approve/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Stock take approved successfully')
      window.location.reload();
    }
  },
}
